import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = {
  key: 1,
  class: "small text-secondary mt-1"
}
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "ms-1" }
const _hoisted_8 = {
  key: 2,
  class: "small text-secondary"
}
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.helper.trans(`antifraudalerts.rule.${_ctx.alert.rule}`)), 1),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.helper.trans(`antifraudalerts.description.${_ctx.alert.rule}.default`, {count: _ctx.data.fakeCount, limit: _ctx.data.limit})), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.helper.trans(`antifraudalerts.description.${_ctx.alert.rule}.deal`)) + ":", 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.data.dealId), 1),
          _createVNode(_component_copy_button, {
            value: _ctx.data.dealId
          }, null, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.data && _ctx.data.verdicts.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.helper.trans(`antifraudalerts.description.${_ctx.alert.rule}.verdicts`)) + ":", 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.data.verdicts.map((verdict) => _ctx.helper.trans(`stopscam.verdict.${verdict}`, {}, verdict)).join(', ')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}